import { render, staticRenderFns } from "./ReviewSettingsPage.vue?vue&type=template&id=0f23b488&"
import script from "./ReviewSettingsPage.vue?vue&type=script&lang=js&"
export * from "./ReviewSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports